import { render, staticRenderFns } from "./html/ShippingCalculator.html?vue&type=template&id=118f910e&lang=html&external"
import script from "./js/ShippingCalculator.js?vue&type=script&lang=js&external"
export * from "./js/ShippingCalculator.js?vue&type=script&lang=js&external"
import style0 from "./scss/ShippingCalculator.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports